<template>
  <div class="my-red-route">
    <div class="top-img" v-if="posterUrl">
      <img src="../../assets/images/title_wdhslx.png" />
    </div>
    <!-- 生成的海报图 -->
    <div class="poster-box" v-show="posterUrl">
      <img class="poster-img" :src="posterUrl" />
    </div>
    <!-- 用来生成小的海报图html结构-上传至服务器 -->
    <div class="route-box-content small-route-box-content">
      <div id="posterRoute" ref="smallPoster">
        <div class="center-bg-img small-center-bg-img">
          <img src="../../assets/images/bg_map_route.png" class="bg" />
        </div>
        <div class="center-bg-img small-center-bg-img">
          <div :class="['icon-text', `icon_${routeListLength}_${index}`]" v-for="(item, index) in routeList" :key="item.id">
            <div :class="['text', `text_${routeListLength}_${index}`, index % 2 == 0 ? 'even' : 'odd']" v-if="index % 2 !== 0">
              {{ item.name }}
            </div>
            <img src="../../assets/images/location_icon.png" class="icon" />
            <div :class="['text', `text_${routeListLength}_${index}`, index % 2 == 0 ? 'even' : 'odd']" v-if="index % 2 == 0">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 海报图的html结构 -->
    <div class="center-route route-box-content" ref="bigPoster">
      <CenterRoute :qrCodeUrl="qrCodeUrl" class="">
        <div>
          <div class="center-bg-img">
            <img src="../../assets/images/bg_map_route.png" class="bg" />
          </div>
          <div class="center-bg-img">
            <div :class="['icon-text', `icon_${routeListLength}_${index}`]" v-for="(item, index) in routeList" :key="item.id">
              <div :class="['text', `text_${routeListLength}_${index}`, index % 2 == 0 ? 'even' : 'odd']" v-if="index % 2 !== 0">
                {{ item.name }}
              </div>
              <img src="../../assets/images/location_icon.png" class="icon" />
              <div :class="['text', `text_${routeListLength}_${index}`, index % 2 == 0 ? 'even' : 'odd']" v-if="index % 2 == 0">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </CenterRoute>
    </div>
    <!-- 底部按钮 -->
    <div class="bottom-btn" v-if="posterUrl">
      <div class="left-btn" @click="handleBack">返回</div>
      <div class="right-text">长按图片保存</div>
    </div>
  </div>
</template>

<script>
import { getRedRouteDetailById, uploadPosterImg } from '@/server/interfaces'
import { mapGetters, mapMutations } from 'vuex'
import renderQrCode from '@/utils/renderQrcode'
import CenterRoute from './components/CenterRoute'
import html2canvas from 'html2canvas'
export default {
  name: 'MyRedRoute',
  components: { CenterRoute },
  data() {
    return {
      routeList: [],
      routeId: '',
      qrCodeUrl: '',
      posterUrl: '',
      activityId: '',
    }
  },
  async mounted() {
    if (!this.userInfo.userUuid) {
      await this.$store.dispatch('userInfo/getUserInfo')
    }
    if (!this.userInfo.userUuid && this.systemInfo.isNfPlus) {
      await this.$store.dispatch('userInfo/getNfplusUserByLogin')
    }
    this.routeId = this.$route.query.routeId
    this.activityId = this.$route.query.id
    await this.initQrCode()
    await this.getDetailByRouteId()
  },
  async created() {},
  computed: {
    ...mapGetters({
      systemInfo: 'systemInfo',
      userInfo: 'userInfo/userInfo',
    }),
    routeListLength() {
      return this.routeList.length
    },
  },
  methods: {
    ...mapMutations({
      showLoading: 'loading/showLoading',
      hideLoading: 'loading/hideLoading',
      showToast: 'toast/showToast',
    }),
    /**生成二维码 */
    async initQrCode() {
      let url = `${window.location.origin}${window.location.pathname}#/shareRoute?routeId=${this.routeId}&id=${this.activityId}`
      const qrCodeOptions = {
        text: url,
        width: 180,
      }
      this.qrCodeUrl = await renderQrCode(qrCodeOptions)
    },
    /**根据路线ID获取路线数据 */
    async getDetailByRouteId() {
      this.showLoading('海报生成中...')
      if (!this.routeId) return
      const params = {
        id: this.routeId,
      }
      const result = await getRedRouteDetailById({ params })
      this.routeList = result.stores
      await this.initPoster()
    },
    /**初始化海报 */
    async initPoster() {
      /**等待更新 */
      await this.$nextTick()
      /**生成需要上传的图，从定制路线页面进来才上传海报 */
      const from = this.$route.query?.from
      if (from === 'create') {
        const smallPoster = this.$refs['smallPoster']
        const baseUrl = await this.html2canvas(smallPoster, { x: -9999, y: -9999 })
        const file = this.dataURLToBlob(baseUrl, `${new Date().getTime()}`)
        /**需要上传完海报图至服务器再生成显示的海报图 */
        await uploadPosterImg({
          file: file,
          id: this.routeId,
        })
      }
      const bigPoster = this.$refs['bigPoster']
      const bigUrl = await this.html2canvas(bigPoster, { x: -9999, y: -9999 })
      // this.html2canvas(bigPoster, { x: -9999, y: -9999 }).then((baseUrl) => {
      this.posterUrl = bigUrl
      this.hideLoading()
      // })
    },
    /**绘制海报 */
    async html2canvas(canvasID, point, scale = 4) {
      return new Promise((resolve) => {
        html2canvas(canvasID, {
          x: -9999,
          y: -9999,
          scrollX: 0,
          scrollY: 0,
          // dpi: window.devicePixelRatio * 1,
          width: canvasID.offsetWidth,
          height: canvasID.offsetHeight,
          backgroundColor: 'transparent',
          useCORS: true,
          scale: window.devicePixelRatio,
          windowWidth: document.body.scrollWidth,
          windowHeight: document.body.scrollHeight,
        }).then((canvas) => {
          resolve(canvas.toDataURL('image/png'))
        })
      })
    },
    //图片格式转为文件流形式
    dataURLToBlob(dataurl, filename = 'file') {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let suffix = mime.split('/')[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime,
      })
    },
    /**返回上一页 */
    handleBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss" scoped>
$scale: 1;
.my-red-route {
  width: 100%;
  height: 100%;
  background: url('../../assets/images/bg_entry.png') no-repeat center center;
  background-size: cover;
  position: relative;
  overflow: hidden;
  .top-img {
    background-size: cover;
    height: 1.22rem;
    & > img {
      width: (7.5rem / $scale);
    }
  }
  .small-center-route {
    height: 5.66rem !important;
  }
  .center-route {
    height: (8.96rem * $scale);
    width: 100%;
    margin: 0 auto;
    margin-bottom: (0.3rem / $scale);
    position: relative;
    // position: absolute;
    // top: -9999px;
    // left: -9999px;
  }
  .small-route-box-content {
    height: 5.66rem !important;
  }
  .route-box-content {
    position: absolute;
    top: -9999px;
    left: -9999px;
    width: 7.5rem;
    height: 8.68rem;
  }
  .small-center-bg-img {
    top: 0 !important;
  }
  .center-bg-img {
    width: 100%;
    height: (5.66rem / $scale);
    position: absolute;
    left: 50%;
    top: (1.3rem / $scale);
    margin-left: -50%;
    & > .bg {
      width: 100%;
      height: 100%;
    }

    .icon-text {
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      // max-width: (3.4rem / $scale);
      /**外层写死高度才能准确定位 */
      height: (0.71rem / $scale);
      & > .icon {
        width: (0.63rem / $scale);
        height: (0.71rem / $scale);
      }
      & > .text {
        background-image: linear-gradient(179deg, #fffcf5 0%, #ffe6d3 100%);
        border: 0.02rem solid #d32300;
        border-radius: 0.1rem;
        font-size: 0.26rem;
        color: #333;
        font-weight: 400;
        padding: (0.1rem / $scale);
        max-width: (2.7rem / $scale);
      }
      .text_5_0 {
        max-width: (2.8rem / $scale);
      }
      & > .text_3_2,
      .text_4_1,
      .text_4_2,
      .text_5_1,
      .text_5_2 {
        max-width: (3.48rem / $scale);
      }
      & > .text_4_3 {
        max-width: (3.1rem / $scale);
      }
      & > .text.even {
        margin-left: (0.1rem / $scale);
      }
      & > .text.odd {
        margin-right: (0.1rem / $scale);
      }
      & > .text.odd::after {
        right: calc(-0.13rem + 0.63rem + 0.1rem);
        border-left: 0.13rem solid #d32300;
      }
      & > .text.even::after {
        left: calc(-0.13rem + 0.63rem + 0.1rem);
        border-right: 0.13rem solid #d32300;
      }
      & > .text::after {
        width: 0px;
        height: 0px;
        content: '';
        border-top: 0.13rem solid transparent;
        border-bottom: 0.13rem solid transparent;
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
      }
    }
    & > .icon_2_0 {
      left: 52.7941%;
      top: 27.9152%;
    }
    & > .icon_2_1 {
      right: 53.8235%;
      top: 62.7208%;
    }
    & > .icon_3_0,
    .icon_4_0,
    .icon_5_0 {
      left: 50%;
      top: 4.59364%;
    }
    & > .icon_3_1 {
      right: 50%;
      top: 37.4558%;
    }
    & > .icon_3_2 {
      left: 43.0882%;
      top: 70.318%;
    }
    & > .icon_4_1 {
      right: 38.2352%;
      top: 28.4452%;
    }
    & > .icon_4_2 {
      left: 31.9118%;
      top: 53.3557%;
    }
    & > .icon_4_3 {
      right: 45%;
      top: 78.0919%;
    }
    & > .icon_5_1 {
      right: 36.7647%;
      top: 24.3816%;
    }
    & > .icon_5_2 {
      left: 35.2941%;
      top: 44.1696%;
    }
    & > .icon_5_3 {
      right: 52.2206%;
      top: 63.9576%;
    }
    & > .icon_5_4 {
      left: 46.47059%;
      top: 79.3286%;
    }
  }
  .poster-box {
    height: (8.06rem * $scale);
    width: calc(100% - 0.7rem);
    margin: 0 auto;
    background: #ffdab4;
    border-radius: 0.2rem;
    position: relative;
    margin-bottom: 0.3rem;
    .poster-img {
      height: 100%;
      width: 100%;
      border-radius: 0.2rem;
    }
  }
  .route-box {
    height: 8.96rem;
    // // width: calc(100% - 0.7rem);
    // margin: 0 auto;
    // background: #ffdab4;
    // border-radius: 0.2rem;
    // position: relative;
  }

  .bottom-btn {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0.35rem;
    font-size: 0.3rem;
    color: #fff;
    font-weight: 400;
    user-select: none;
    -moz-user-select: none; /* Firefox私有属性 */
    -webkit-user-select: none; /* WebKit内核私有属性 */
    -ms-user-select: none; /* IE私有属性(IE10及以后) */
    -khtml-user-select: none; /* KHTML内核私有属性 */
    -o-user-select: none; /* Opera私有属性 */
    .left-btn {
      width: 1.63rem;
      height: 0.75rem;
      text-align: center;
      line-height: 0.75rem;
      background: rgba(0, 0, 0, 0.49);
      border-radius: 0.38rem;
      color: #fff;
    }
  }
  #posterRoute {
    width: 100%;
    height: (5.66rem / $scale);
  }
}
</style>